import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAuthenticated, setIsAuthenticated }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if user is authenticated
        const authStatus = localStorage.getItem('adminAuthenticated');
        const loginTime = localStorage.getItem('adminLoginTime');

        // Session expires after 24 hours
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const isSessionValid = loginTime && (Date.now() - parseInt(loginTime)) < twentyFourHours;

        if (authStatus === 'true' && isSessionValid) {
            setIsAuthenticated(true);
        } else {
            // Clear expired session
            localStorage.removeItem('adminAuthenticated');
            localStorage.removeItem('adminLoginTime');
            setIsAuthenticated(false);
        }
        setLoading(false);
    }, [setIsAuthenticated]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh'
            }}>
                Loading...
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/admin" replace />;
};

export default ProtectedRoute;
